<ng-template>
    <div class="tt-side-drawer" [style.width]="ttWidth">
        <!-- <mat-drawer opened [position]="ttPosition" mode="side"> -->
        <ng-content></ng-content>
        <!-- </mat-drawer> -->
    </div>
</ng-template>
